import getRoutes from 'config/routes';

function AppContainer() {
  return (
      <div id="app">
        <div className="app-wrapper">
          <div className="app-wrapper-container">
            { getRoutes() }
          </div>
        </div>
      </div>
  );
}

export default AppContainer;